const HAG_HATS = [
  {
    slug: "hag-black-15",
    name: "Hag",
    description: "Dark magic user",
    rarity: "rare",
    slot: "hat",
    statChanges: [
      {
        stat: "blackColor",
        value: 20
      },
      {
        stat: "blackRes",
        value: 10
      },
      {
        stat: "redColor",
        value: 6
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_black",
      frameIndex: 15
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "yellow-hag-yellow-4",
    name: "Yellow Hag",
    description: "Dark magic user, pestilence",
    rarity: "rare",
    slot: "hat",
    statChanges: [
      {
        stat: "goldColor",
        value: 20
      },
      {
        stat: "goldRes",
        value: 10
      },
      {
        stat: "greenColor",
        value: 6
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_yellow",
      frameIndex: 4
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "orange-hag-orange-4",
    name: "Orange Hag",
    description: "Dark magic user, turns children into pumpkins",
    rarity: "epic",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 35
      },
      {
        stat: "greenRes",
        value: 15
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_orange",
      frameIndex: 4
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "green-hag-green-4",
    name: "Green Hag",
    description: "Dark magic user, turns children into frogs",
    rarity: "epic",
    slot: "hat",
    statChanges: [
      {
        stat: "greenColor",
        value: 35
      },
      {
        stat: "greenRes",
        value: 15
      },
      {
        stat: "blueColor",
        value: 10
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_green",
      frameIndex: 4
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  }
];
export {
  HAG_HATS
};
//# sourceMappingURL=data:application/json;base64,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
